<template>
  <div class="bar_wrap">
    <div ref="barcharts" id="barcharts" class="barcharts"></div>
  </div>
</template>
<script>
import echarts from 'echarts'
var option = {
  tooltip: {
    trigger: 'axis',
    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
      type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
    },
    textStyle: {

      align: 'left'

    },
    confine: true,
    // formatter: `扫描区域：${'b0'}{b0} <br /> 本次数值: {c0} <br /> 标准范围: ≥ {c1}，越高越好`,
    formatter: function (params, ticket, callback) {
     console.log(params)
     let qname = ''
     if(params[0].name == '第一体区'){
      qname = '左额→左手'
     }else if(params[0].name == '第二体区'){
      qname = '左手→左额'
     }else if(params[0].name == '第三体区'){
      qname = '右额→右手'
     }else if(params[0].name == '第四体区'){
      qname = '右手→右额'
     }else if(params[0].name == '第九体区'){
      qname = '左额→右额'
     }else if(params[0].name == '第十体区'){
      qname = '右额→左额'
     }else if(params[0].name == '第十五体区'){
      qname = '右手→左额'
     }else if(params[0].name == '第十六体区'){
      qname = '左额→右手'
     }else if(params[0].name == '第十七体区'){
      qname = '左手→右额'
     }else if(params[0].name == '第十八体区'){
      qname = '右额→左手'
     }
      return `扫描区域：${qname} <br /> 本次数值: ${params[0].value} <br /> 标准范围: ≥ ${params[1].value}，越高越好`
    }
  },
  grid: {
    left: 20,
    right: 20,
    bottom: 15,
    top: 10,
    containLabel: true
  },
  xAxis: [
    {
      type: 'value',
      axisLine: {
        lineStyle: {
          color: '#999'
        }
      },
      data: [0, 10, 20, 30, 40, 50],
      axisLabel: {
        //color: '#666'
      }
    }
  ],
  yAxis: [
    {
      type: 'category',
      axisTick: { show: false },
      data: [],
      axisLine: {
        lineStyle: {
          color: '#999'
        }
      },
      axisLabel: {
        color: '#666',
        fontSize:16
      }
    }
  ],
  series: [
    {
      name: '',
      type: 'bar',
      barWidth: 20,
      barGap: '20%',
      label: {
        normal: {
          show: true,
          position: 'inside',
          textStyle: {	    //数值样式
            color: '#fff',
            fontSize: 14,
            align: 'left'
          }
        }
      },
      data: [],
      itemStyle: {
        normal: {
          //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
          color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
            offset: 0,
            color: '#677FE2'
          }, {
            offset: 1,
            color: '#7EE1E9'
          }])

        }
      },
    },
    {
      name: '标准范围',
      type: 'line',
      showSymbol: true,
      symbol: 'circle',     //折点设定为实心点
      symbolSize: 8,   //设定实心点的大小
      itemStyle: {
        normal: {
          color: '#fc8a0f', //折点颜色
          lineStyle: {
            color: '#ff9c35' //折线颜色
          }
        }
      },
      data: [40, 40, 40, 40, 60, 60, 40, 40, 40, 40],
    }
  ]
};
export default {
  props: ['barlist'],
  data() {
    return {
    }
  },
  methods: {
    initCharts() {
      let charts = this.$echarts.init(this.$refs.barcharts);
      option.yAxis[0].data = this.barlist.map(e => {
        return e.name
      })
      option.series[0].data = this.barlist.map(e => {
        return e.functional_status
      });

      charts.setOption(option);
    }
  },
  created() {
    this.$nextTick(() => {
      this.initCharts()
    })
  }
}
</script>
<style lang="scss" scoped>
.barcharts {
  width: 700px;
  height: 640px;
}
</style>